import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

//公共组件 头部、底部、面包屑...
const Layout = () =>  import ('../components/layout/layout');
const LayoutContent = () => import ('../components/layout/layoutContent');
//登陆
const Login = () =>  import ('../page/login');
//主页
const home = () => import ('../page/main/home');
//errorView-没有权限
const errorView = () => import ('../page/errorView');
//404
const err404 = () => import ('../page/404');
//测试
const test = () => import ('../page/test');
//水印测试
const textTest = () =>  import ('../page/textTest');
//空白路由
const empty = () => import ('../page/empty');

//订单管理
const softwareList = () => import ("../page/main/accountorder/orderManagement/index");
const softwareLogin = () => import ("../page/main/accountorder/orderManagement/login");
const softwareLoginSvj = () =>  import ("../page/main/accountorder/orderManagement/loginSvj");
const softwareLoginKjl = () =>  import ("../page/main/accountorder/orderManagement/loginKjl");
const softwareBinding = () => import ("../page/main/accountorder/orderManagement/binding/index");
const softwareServe = () => import ("../page/main/accountorder/orderManagement/accountMessage/accountServe");
const orderComponent = () =>  import ('../page/main/accountorder/orderManagement/newAddOrder/index')
const orderComponentV2 = () =>  import ('../page/main/accountorder/orderManagement/newAddOrderV2/index')
const orderComponentKjl = () =>  import ('../page/main/accountorder/orderManagement/kjlAddOrder/index')
const orderManage = () =>  import ('../page/main/accountorder/orderManagement/orderManage/index')
const softDetail = () => import ('../page/main/accountorder/orderManagement/newAddOrder/detail')
const orderAudit = () =>  import ('../page/main/accountorder/orderAudit/index') //订单审核列表
const orderRe = () =>  import ('../page/main/accountorder/orderAudit/orderRe/index') //订单处理
const orderRevoke = () => import ('../page/main/accountorder/orderAudit/orderRe/revoke') //订单撤销
const role = () => import ("../page/main/accountorder/orderManagement/role");
const orderExternal = () => import ("../page/main/accountorder/orderExternal/index"); //渠道订单
/*const singleTemplate = () => import("../page/main/caseBase/templateBase/singleTemplate/index") //单品样板库
const singleTemplateDetail = () => import("../page/main/caseBase/templateBase/singleTemplate/detail") //单品样板库详情页*/

//集团内部
const costManagement = () => import('../page/main/accountorder/costManagement/index') //账号购买费用管理
const costDetails = () =>  import('../page/main/accountorder/costManagement/details') //费用清单明细查询
// const accountRecharge = () =>  import('../page/main/accountorder/costManagement/recharge') //费用清单明细查询

//通用营销计费管理功能
const marketDeduction = () => import('../page/main/accountorder/marketManagement/deduction') //设计账户开通扣费清单确认管理
const marketRecharge = () => import('../page/main/accountorder/marketManagement/recharge') //虚拟账户充值扣费清单确认管理
const marketDeductionVirtual = () => import('../page/main/accountorder/marketManagement/deductionVirtual') //虚拟账户扣费清单管理功能
const marketQueryVirtual = () =>import('../page/main/accountorder/marketManagement/queryVirtual') //虚拟账户信息查询功能

const caxaMtds = () => import ('../page/main/accountorder/caxaMtds/index') // 对接caxa
const caxaMtdsPay = () => import ('../page/main/accountorder/caxaMtdsPay/index') // 对接caxa支付
const payListMange = () => import ('../page/main/accountorder/payListManage/index') // 第三方支付清单管理
const serviceConsumptionInquiry = () => import ('../page/main/accountorder/serviceConsumptionInquiry/index') // 套餐开通用量查询页面

const myInterest = () => import ('../page/main/accountorder/equityManagement/myInterest/index') // 我的权益

const myInterestDetail = () => import ('../page/main/accountorder/equityManagement/myInterest/details') // 我的权益

const myInterestList = () => import ('../page/main/accountorder/equityManagement/myInterestList/index') // 我的权益消费清单

const myRightsManagement = () => import ('../page/rights-platform/mine/index')


Vue.use(Router);

export const constantRouterMap = [
    { path: '/', redirect: '/index', hidden: true },
    { path: '/index', name: '设计软件订单查询', component: softwareList, permission: "ORDER_INDEX", meta: { keepAlive: true } },
    { path: '/login', name: '设计软件登录', component: softwareLogin, permission: "ORDER_LOGIN" },
    { path: '/loginSvj', name: '三维家登录', component: softwareLoginSvj, permission: "ORDER_LOGIN" },
    { path: '/loginKjl', name: '酷家乐登录', component: softwareLoginKjl, permission: "ORDER_LOGIN" },
    { path: '/account_binding', name: '设计软件账号绑定管理', component: softwareBinding, permission: "BINDING_VALIDATE" },
    { path: '/account_binding_group', name: '设计软件账号绑定管理(内部人员)', component: softwareBinding},
    { path: '/accountMessage/accountServe', name: '账号已购服务查询', component: softwareServe, permission: "ORDER_LOGIN", hidden: true },
    { path: '/newAddOrder/index', name: '新增订单', component: orderComponent, permission: "ORDER_LOGIN", hidden: true },
    { path: '/newAddOrderV2/index', name: 'newAddOrderV2', component: orderComponentV2, permission: "ORDER_LOGIN", hidden: true },
    { path: '/kjlAddOrder/index', name: '酷家乐模型与下单权限申请', component: orderComponentKjl, permission: "ORDER_LOGIN", hidden: true },
    { path: '/billingProjectManage', name: '计费项目管理', component: orderManage, permission: "", hidden: true },
    { path: '/newAddOrder/:id/edit', name: '修改订单', component: orderComponent, permission: "ORDER_LOGIN", hidden: true },
    { path: '/newAddOrder/:id/detail', name: '订单详情', component: softDetail, permission: "ORDER_LOGIN", hidden: true },
    { path: '/orderAudit', name: '订单审核', component: orderAudit, permission: "ORDER_LOGIN", hidden: true },
    { path: '/orderAudit/orderRe', name: '订单处理', component: orderRe, permission: "ORDER_LOGIN", hidden: true },
    { path: '/orderAudit/orderRevoke', name: '订单撤销', component: orderRevoke, permission: "ORDER_LOGIN", hidden: true },
    { path: '/roleList', name: '用户列表', component: role, permission: "ORDER_LOGIN", hidden: true },
    { path: '/orderExternal', name: '渠道订单查询', component: orderExternal, permission: "ORDER_LOGIN", hidden: true },
    { path: '/indexGroup', name: '集团内部账号开通', component: softwareList, permission: "ORDER_LOGIN", hidden: true, meta: { keepAlive: true } },
    { path: '/newAddOrder/indexGroup', name: '集团内部账号新增订单', component: orderComponent, permission: "ORDER_LOGIN", hidden: true },
    { path: '/newAddOrder/:id/editGroup', name: '集团内部账号修改订单', component: orderComponent, permission: "ORDER_LOGIN", hidden: true },
    { path: '/costManagement', name: '设计账号费用管理', component: costManagement, permission: "ORDER_LOGIN", hidden: true },
    { path: '/costDetails', name: '费用清单明细查询', component: costDetails, permission: "ORDER_LOGIN", hidden: true },
    // { path: '/accountRecharge', name: '账号充值', component: accountRecharge, permission: "ORDER_LOGIN", hidden: true },
    { path: '/marketDeduction', name: '设计账户开通扣费清单确认管理', component: marketDeduction, permission: "ORDER_LOGIN", hidden: true },
    { path: '/marketRecharge', name: '虚拟账户充值扣费清单确认管理', component: marketRecharge, permission: "ORDER_LOGIN", hidden: true },
    { path: '/marketDeductionVirtual', name: '虚拟账户扣费清单管理功能', component: marketDeductionVirtual, permission: "ORDER_LOGIN", hidden: true },
    { path: '/marketQueryVirtual', name: '虚拟账户信息查询功能', component: marketQueryVirtual, permission: "ORDER_LOGIN", hidden: true },
    {
        path: '/resources/main',
        redirect: '/resources/main/home',
        name: '首页',
        component: Layout,
        icon: 'zhuye',
        noDropdown: true,
        children: [
            { path: 'home', name: '', component: home, hidden: true },
            { name: 'errorView', path: 'errorView', component: errorView, hidden: true },
        ],
    },
    { path: '/resources/test', name: 'test', component: test, hidden: true, }, //测试
    { path: '/resources/textTest', name: 'textTest', component: textTest, hidden: true, }, //水印测试
    { path: '/resources/404', name: 'notFound', component: err404, hidden: true, }, //找不到该页面
    { path: '/resources/empty', name: '&nbsp;', component: empty, hidden: true, }, //空白页面
    { path: '/;jsessionid=*', name: 'jsessionid', redirect: '/', hidden: true, }, //偶尔后端会把那个jsessionid带出来,但是前端格式处理不了,要单独处理
    { path: '/caxaMtds', name: 'caxaMtdx', component: caxaMtds, permission: "CAXA_MTDS", meta: { keepAlive: true } },
    { path: '/caxaMtdsPay', name: 'caxaMtdxPay', component: caxaMtdsPay, permission: "CAXA_MTDS_PAY", meta: { keepAlive: true } },
    { path: '/paymentListManage', name: 'paymentListManage', component: payListMange, permission: "PAY_LIST_MANAGE", meta: { keepAlive: true } },
    { path: '/serviceConsumptionInquiry', name: 'serviceConsumptionInquiry', component: serviceConsumptionInquiry, permission: "SERVICE_CONSUMPTION_INQUIRY", meta: { keepAlive: true } },
    { path: '/myInterest', name: 'myInterest', component: myInterest, hidden: true },
    { path: '/myInterestDetail', name: 'myInterestDetail', component: myInterestDetail, hidden: true },
    { path: '/myInterestList', name: 'myInterestList', component: myInterestList, hidden: true },
  {
    path: '/rights/mine',
    name: 'myRightsManagement',
    component: myRightsManagement
  },
    { path: '*', name: '404', redirect: '/resources/404' },
]
export default new Router({
    mode: 'history',
    base: process.env.ROUTER_PATH,
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})

export const asyncRouterMap = [{
    path: "/resources/main/orderManagement",
    name: "订单管理",
    redirect: "/resources/main/orderManagement/index",
    permission: "ORDER",
    component: Layout,
    icon: 'liebiao',
}];



// WEBPACK FOOTER //
// ./src/router/index.js